/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Agent_Schedule_Summary_WeeklyInputs */



/**
* | output |
* | --- |
* | "Every {day} at {time}" |
*
* @param {Agent_Schedule_Summary_WeeklyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_weekly = /** @type {((inputs: Agent_Schedule_Summary_WeeklyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_WeeklyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Jeden ${i?.day} um ${i?.time}`)
	return /** @type {LocalizedString} */ (`Every ${i?.day} at ${i?.time}`)
});